import type { DescriptionsProps as AntDescriptionsProps } from "antd";
import { Descriptions as AntDescriptions } from "antd";
import type { DescriptionsItemType } from "antd/es/descriptions";
import React from "react";
import styled from "styled-components";
import themeColors from "styles/themeColors";

export interface DescriptionsProps extends AntDescriptionsProps {}

export interface DescriptionsItemProps extends DescriptionsItemType {}

const StyledDescriptions = styled(AntDescriptions)`
  /* Mobile responsive styles for screens 500px or smaller */
  @media (max-width: 500px) {
    &.ant-descriptions {
      width: 100%;
    }
    
    .ant-descriptions-view {
      border: none;
      width: 100%;
    }
    
    .ant-descriptions-view > table {
      width: 100%;
      display: block;
    }
    
    .ant-descriptions-view > table > tbody {
      display: block;
      width: 100%;
    }
    
    .ant-descriptions-row {
      display: flex !important;
      flex-direction: column !important;
      border: none !important;
      width: 100%;
      
      > th.ant-descriptions-item-label {
        display: block !important;
        width: 100% !important;
        padding: 0.75rem 0 0.25rem 0 !important;
        border: none !important;
        text-align: left !important;
        background: transparent !important;
        
        &:first-child {
          padding-top: 0 !important;
        }
        
        > span {
          display: inline-block;
          font-weight: 600;
          color: inherit;
        }
      }
      
      > td.ant-descriptions-item-content {
        display: block !important;
        width: 100% !important;
        padding: 0 0 0.5rem 0 !important;
        border: none !important;
        text-align: left !important;
        background: transparent !important;
        word-break: break-word;
        
        > span {
          display: inline-block;
          width: 100%;
        }
      }
    }
    
    /* Handle multiple items in a row - each should stack */
    .ant-descriptions-row > .ant-descriptions-item {
      display: contents !important;
    }
    
    /* Ensure proper ordering of label-content pairs */
    .ant-descriptions-row {
      > * {
        order: initial !important;
      }
    }
    
    /* Ensure title has proper spacing */
    .ant-descriptions-header {
      margin-bottom: 0.75rem;
    }
    
    /* Remove any colspans for mobile */
    [colspan] {
      width: 100% !important;
    }
  }
`;

const Descriptions = ({ ...props }: DescriptionsProps) => {
  return (
    <StyledDescriptions
      contentStyle={{ color: "black" }}
      labelStyle={
        props.bordered
          ? {
              color: "black",
              fontWeight: "bold",
            }
          : {
              color: themeColors.neutral.dark,
            }
      }
      {...props}
    />
  );
};

export default Descriptions;
